import { TourDossiersParams, ToursApi } from '@model/iceberg/service/tours';
import { TourDossier } from '@model/tours';
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TourActions } from '@state/slices/tours/tourActions';

export enum TourDossiersActions {
  FETCH_TOUR_DOSSIERS = '@TOURS/FETCH_TOUR_DOSSIERS'
}

export interface TourDossiersState {
  data: Array<TourDossier>;
  loading: boolean;
  error: string | null;
}

export const INITIAL_TOUR_DOSSIERS_STATE: TourDossiersState = {
  data: [],
  loading: false,
  error: null
};

export const fetchTourDossiers = createAsyncThunk(
  TourDossiersActions.FETCH_TOUR_DOSSIERS,
  async (params: TourDossiersParams, { rejectWithValue }) => {
    try {
      const api = new ToursApi();
      const response = await api.getTourDossiers(params);

      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message || 'Failed to fetch tour dossiers');
    }
  }
);

const tourDossiersSlice = createSlice({
  name: TourActions.SLICE_NAME,
  initialState: INITIAL_TOUR_DOSSIERS_STATE,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTourDossiers.pending, (state) => {
        state.loading = true;
        state.data = INITIAL_TOUR_DOSSIERS_STATE.data;
        state.error = null;
      })
      .addCase(fetchTourDossiers.fulfilled, (state, action: PayloadAction<Array<TourDossier>>) => {
        state.loading = false;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(fetchTourDossiers.rejected, (state, action) => {
        state.loading = false;
        state.error = (action.payload as string) || 'Unknown error occurred';
        state.data = INITIAL_TOUR_DOSSIERS_STATE.data;
      });
  }
});

export const tourDossiersReducer = tourDossiersSlice.reducer;
